/**
 * The one seeded RNG (doc 12: "all randomness through one seeded RNG").
 *
 * mulberry32: tiny, fast, and — the property that matters — identical output on
 * every platform, because it is pure 32-bit integer arithmetic. The global
 * unseeded RNG is banned from `src/sim/` entirely (a test enforces this): any
 * randomness that bypasses the seed breaks replays, the balance harness, and
 * determinism as identity (doc 13 §G item 2).
 */

export class Rng {
  private s: number;

  constructor(seed: number) {
    this.s = seed >>> 0;
  }

  /** Uniform float in [0, 1). */
  next(): number {
    this.s = (this.s + 0x6d2b79f5) >>> 0;
    let t = this.s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  /** Uniform integer in [0, n). */
  int(n: number): number {
    return Math.floor(this.next() * n);
  }

  /** Uniform float in [lo, hi). */
  range(lo: number, hi: number): number {
    return lo + this.next() * (hi - lo);
  }

  /** The internal state, for snapshots. */
  state(): number {
    return this.s;
  }

  restore(state: number): void {
    this.s = state >>> 0;
  }
}
